export const state = () => ({
  HomeTop: 0,
  ScreenTop: 0,
  gotoHome: false
})

export const mutations = {
  setHomeTop (state, top) {
    state.HomeTop = top
  },
  setScreenTop (state, top) {
    state.ScreenTop = top
  },
  setGotoHome (state, go) {
    state.gotoHome = go
  }
}